<template>
  <v-layout>
    <v-card class="card-box">
      <v-card-title class="subheading font-weight-bold justify-center">
        Related Keywords
        <v-icon style="font-size: 18px;" class="ml-1 pointer"
          v-tooltip.top-center="{
            content: 'More contextually related keywords to your key-phrase',
            trigger: $store.state.metadata.windowWidth > 600 ? 'hover' : 'click'
          }"
        >help_outline</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-list dense>
        <template>
          <v-data-table
            class="table-competition"
            :headers="headerRelatedKeywords"
            :items="relatedKeywords.length ? relatedKeywords.slice(0, 5) : []"
            :hide-actions="true"
            item-key="name"
          >
            <template v-slot:items="props" v-if="relatedKeywords && relatedKeywords.length > 0">
              <tr>
                <td>{{ props.item.suggestion ? props.item.suggestion : '-' }}</td>
                <td class="text-xs-center">
                  {{ props.item.volume }}
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <tr>
                <td class="text-xs-center" colspan="4">
                  <span>No data available</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
        <v-list-tile>
          <v-list-tile-content v-if="relatedKeywords && relatedKeywords.length > 0" :style="{ 'align-items':'center' }">
            <a v-if="$store.state.user.email" @click="relatedKeywordsDialog = true">View more</a>
            <a v-else @click="$router.push({name: 'Login'})">Login to see more</a>
          </v-list-tile-content>
          <!-- <v-list-tile-content class="align-end">protein</v-list-tile-content> -->
        </v-list-tile>
      </v-list>
    </v-card>
    <RelatedKeywordsBoxModal v-if="relatedKeywordsDialog" :relatedKeywordsDialog="relatedKeywordsDialog" :relatedKeywords="relatedKeywords" :engineId="engineId"></RelatedKeywordsBoxModal>
  </v-layout>
</template>

<script>
export default {
  name: 'RelatedKeywordsBox',
  props: ['relatedKeywords', 'engineId'],
  data () {
    return {
      loading: false,
      // testData: [{'keyword': 'test 1', 'volume': 1}, {'keyword': 'test 1', 'volume': 1}, {'keyword': 'test 1', 'volume': 1}, {'keyword': 'test 1', 'volume': 1}, {'keyword': 'test 1', 'volume': 1}],
      relatedKeywordsDialog: false,
      // relatedKeywords: [],
      headerRelatedKeywords: [
        { text: 'Keyword', value: 'suggestion', sortable: false },
        { text: 'Volume', value: 'volume', sortable: false, align: 'middle' }
      ]
    }
  },
  mounted () {
    this.$on('relatedKeywordsDialog', (value) => {
      this.relatedKeywordsDialog = value
    })
    // this.relatedKeywords = this.testData
  },
  beforeDestroy () {
    this.$off('relatedKeywordsDialog')
  },
  methods: {
    // getLinksBox () {
    //   if (this.isAdmin || this.$store.state.user.permissions.links_box) {
    //     let params = {
    //       top: 5,
    //       engine_id: parseInt(this.$route.params.engineId)
    //     }
    //     this.loading = true
    //     this.$store.dispatch('GET_LINKS_BOX', { projectId: this.projectId, params: params }).then(res => {
    //       this.linksBoxAdditional.lastUpdate = res.last_update
    //       this.linksBoxAdditional.ignoredLinks = res.ignored_links_without_ranking
    //       this.linksBox = res.data
    //       this.loading = false
    //     }, err => {
    //       this.loading = false
    //       console.log('GET_LINKS_BOX error', err)
    //       let errorText = this.$services.getApiError(err)
    //       if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
    //     })
    //   }
    // }
  }
}
</script>

<style lang="scss">
  .card-box {
    min-height: 404px;
    width: 100%;
  }
  .table-competition .v-datatable.v-table thead tr th {
    padding: 0 5px;
  }
  .table-competition .v-datatable.v-table thead tr th:first-child {
    padding-left: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/boxes/RelatedKeywordsBox.vue